<template>
  <v-container>
    <v-layout row wrap>
      <v-flex :class="['pa-2']">
        <a :href="this.$config.merchSite" target="_blank" :class="['white--text']" :title="$lang.goToMerch" v-text="$lang.goToMerch.toUpperCase()" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'PageMerch',
  mounted () {
    this.$router.push({
      path: '/'
    }).then(() => {
      window.open(this.$config.merchSite, '_blank')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/merch.vue